import { OverlayRef } from '@angular/cdk/overlay';
import { Subject, Observable, BehaviorSubject } from 'rxjs';

export class RmsPulldownRef<R = any> {
  canClose: () => boolean = () => true;
    private readonly _closed$ = new Subject<R | undefined>();
  private readonly _dataReturned$ = new Subject<R | undefined>();
  private dataSubject = new Subject<R | undefined>();
  private _closed = false;

  constructor(
    private readonly overlayRef: OverlayRef,
    private readonly closeFn: (result?: R) => void
  ) { }

    returnData(result?: R): Observable<R | undefined> {
       return this._dataReturned$.asObservable();
    }

    sendData(result?: R): void {
        if (this._closed) return;
        this._dataReturned$.next(result);
    }

  close(result?: R) {
    if (this._closed || !this.canClose()) return;
    this._closed = true;
    this.closeFn(result);
  }

  afterClosed(): Observable<R | undefined> {
    return this._closed$.asObservable();
  }

  /** internal */
  _finishClose(result?: R) {
    this._closed$.next(result);
    this._closed$.complete();
    this.overlayRef.dispose();
  }

  dataChanges() {
    return this.dataSubject.asObservable();
  }

  updateData(data: any) {
    this.dataSubject.next(data);
  }

}
